module.exports = __webpack_public_path__ + "static/media/su.949c8bfb.png";